import { AxiosError } from "axios";
import http from "infra/http";
import { useQuery } from "react-query";
import { TipoVeiculo } from "../typings";

export function useListarTiposVeiculo() {
  return useQuery<TipoVeiculo[], AxiosError>(
    "/v1/veiculo/tipos",
    async () => {
      const {data} = await http.get<TipoVeiculo[]>('v1/veiculo/tipos');

      return data;
    }
  );
}
